<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Shirley Deuchrass was born in Dunedin, New Zealand, and grew up on a farm in South Otago. She was educated in Dunedin, where she developed a love for writing. Although her first career path was nursing, she gained a BA in English at Otago University in 2003 and began writing in earnest.</p>
<p>Many of her poems grace the pages of <em>Blackmail Press</em>, <em>PoetryNZ</em> and <em>Takahe</em> magazines. A collection of poems was published in a book in 2010 titled <em>River Calls Me Home</em>.</p>
<p>Shirley’s writing history includes a self-published children’s novel called <em>Isabella’s Diary</em> in 2005 and several biographical titles.</p>
<p>She is married, with four children and seven grandchildren and currently lives in Wanaka, New Zealand.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?1beb8a1c